/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as BemVindoRouteImport } from './routes/bem-vindo'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedAgendaRouteImport } from './routes/_authed/agenda'
import { Route as AuthedConfiguracoesRouteImport } from './routes/_authed/configuracoes'
import { Route as AuthedFilaRouteImport } from './routes/_authed/fila'
import { Route as PublicCadastroRouteImport } from './routes/_public/cadastro'
import { Route as PublicEsqueciSenhaRouteImport } from './routes/_public/esqueci-senha'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as PublicRedefinirSenhaRouteImport } from './routes/_public/redefinir-senha'
import { Route as AuthedClientesIndexRouteImport } from './routes/_authed/clientes.index'
import { Route as AuthedClientesCustomerIdRouteImport } from './routes/_authed/clientes.$customerId'
import { Route as AuthedConfiguracoesIndexRouteImport } from './routes/_authed/configuracoes.index'
import { Route as AuthedConfiguracoesAgendamentoRouteImport } from './routes/_authed/configuracoes.agendamento'
import { Route as AuthedConfiguracoesContaRouteImport } from './routes/_authed/configuracoes.conta'
import { Route as AuthedConfiguracoesPagamentosRouteImport } from './routes/_authed/configuracoes.pagamentos'
import { Route as AuthedConfiguracoesPainelRouteImport } from './routes/_authed/configuracoes.painel'
import { Route as AuthedConfiguracoesProfissionaisRouteImport } from './routes/_authed/configuracoes.profissionais'
import { Route as AuthedConfiguracoesSalaoRouteImport } from './routes/_authed/configuracoes.salao'
import { Route as AuthedConfiguracoesServicosRouteImport } from './routes/_authed/configuracoes.servicos'
import { Route as AuthedConfiguracoesWhatsappRouteImport } from './routes/_authed/configuracoes.whatsapp'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const BemVindoRoute = BemVindoRouteImport.update({
  id: '/bem-vindo',
  path: '/bem-vindo',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAgendaRoute = AuthedAgendaRouteImport.update({
  id: '/agenda',
  path: '/agenda',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedConfiguracoesRoute = AuthedConfiguracoesRouteImport.update({
  id: '/configuracoes',
  path: '/configuracoes',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFilaRoute = AuthedFilaRouteImport.update({
  id: '/fila',
  path: '/fila',
  getParentRoute: () => AuthedRoute,
} as any)
const PublicCadastroRoute = PublicCadastroRouteImport.update({
  id: '/cadastro',
  path: '/cadastro',
  getParentRoute: () => PublicRoute,
} as any)
const PublicEsqueciSenhaRoute = PublicEsqueciSenhaRouteImport.update({
  id: '/esqueci-senha',
  path: '/esqueci-senha',
  getParentRoute: () => PublicRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const PublicRedefinirSenhaRoute = PublicRedefinirSenhaRouteImport.update({
  id: '/redefinir-senha',
  path: '/redefinir-senha',
  getParentRoute: () => PublicRoute,
} as any)
const AuthedClientesIndexRoute = AuthedClientesIndexRouteImport.update({
  id: '/clientes/',
  path: '/clientes/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedClientesCustomerIdRoute =
  AuthedClientesCustomerIdRouteImport.update({
    id: '/clientes/$customerId',
    path: '/clientes/$customerId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedConfiguracoesIndexRoute =
  AuthedConfiguracoesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedConfiguracoesRoute,
  } as any)
const AuthedConfiguracoesAgendamentoRoute =
  AuthedConfiguracoesAgendamentoRouteImport.update({
    id: '/agendamento',
    path: '/agendamento',
    getParentRoute: () => AuthedConfiguracoesRoute,
  } as any)
const AuthedConfiguracoesContaRoute =
  AuthedConfiguracoesContaRouteImport.update({
    id: '/conta',
    path: '/conta',
    getParentRoute: () => AuthedConfiguracoesRoute,
  } as any)
const AuthedConfiguracoesPagamentosRoute =
  AuthedConfiguracoesPagamentosRouteImport.update({
    id: '/pagamentos',
    path: '/pagamentos',
    getParentRoute: () => AuthedConfiguracoesRoute,
  } as any)
const AuthedConfiguracoesPainelRoute =
  AuthedConfiguracoesPainelRouteImport.update({
    id: '/painel',
    path: '/painel',
    getParentRoute: () => AuthedConfiguracoesRoute,
  } as any)
const AuthedConfiguracoesProfissionaisRoute =
  AuthedConfiguracoesProfissionaisRouteImport.update({
    id: '/profissionais',
    path: '/profissionais',
    getParentRoute: () => AuthedConfiguracoesRoute,
  } as any)
const AuthedConfiguracoesSalaoRoute =
  AuthedConfiguracoesSalaoRouteImport.update({
    id: '/salao',
    path: '/salao',
    getParentRoute: () => AuthedConfiguracoesRoute,
  } as any)
const AuthedConfiguracoesServicosRoute =
  AuthedConfiguracoesServicosRouteImport.update({
    id: '/servicos',
    path: '/servicos',
    getParentRoute: () => AuthedConfiguracoesRoute,
  } as any)
const AuthedConfiguracoesWhatsappRoute =
  AuthedConfiguracoesWhatsappRouteImport.update({
    id: '/whatsapp',
    path: '/whatsapp',
    getParentRoute: () => AuthedConfiguracoesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/bem-vindo': typeof BemVindoRoute
  '/agenda': typeof AuthedAgendaRoute
  '/configuracoes': typeof AuthedConfiguracoesRouteWithChildren
  '/fila': typeof AuthedFilaRoute
  '/cadastro': typeof PublicCadastroRoute
  '/esqueci-senha': typeof PublicEsqueciSenhaRoute
  '/login': typeof PublicLoginRoute
  '/redefinir-senha': typeof PublicRedefinirSenhaRoute
  '/clientes/$customerId': typeof AuthedClientesCustomerIdRoute
  '/configuracoes/agendamento': typeof AuthedConfiguracoesAgendamentoRoute
  '/configuracoes/conta': typeof AuthedConfiguracoesContaRoute
  '/configuracoes/pagamentos': typeof AuthedConfiguracoesPagamentosRoute
  '/configuracoes/painel': typeof AuthedConfiguracoesPainelRoute
  '/configuracoes/profissionais': typeof AuthedConfiguracoesProfissionaisRoute
  '/configuracoes/salao': typeof AuthedConfiguracoesSalaoRoute
  '/configuracoes/servicos': typeof AuthedConfiguracoesServicosRoute
  '/configuracoes/whatsapp': typeof AuthedConfiguracoesWhatsappRoute
  '/clientes/': typeof AuthedClientesIndexRoute
  '/configuracoes/': typeof AuthedConfiguracoesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthedIndexRoute
  '/bem-vindo': typeof BemVindoRoute
  '/agenda': typeof AuthedAgendaRoute
  '/fila': typeof AuthedFilaRoute
  '/cadastro': typeof PublicCadastroRoute
  '/esqueci-senha': typeof PublicEsqueciSenhaRoute
  '/login': typeof PublicLoginRoute
  '/redefinir-senha': typeof PublicRedefinirSenhaRoute
  '/clientes/$customerId': typeof AuthedClientesCustomerIdRoute
  '/configuracoes/agendamento': typeof AuthedConfiguracoesAgendamentoRoute
  '/configuracoes/conta': typeof AuthedConfiguracoesContaRoute
  '/configuracoes/pagamentos': typeof AuthedConfiguracoesPagamentosRoute
  '/configuracoes/painel': typeof AuthedConfiguracoesPainelRoute
  '/configuracoes/profissionais': typeof AuthedConfiguracoesProfissionaisRoute
  '/configuracoes/salao': typeof AuthedConfiguracoesSalaoRoute
  '/configuracoes/servicos': typeof AuthedConfiguracoesServicosRoute
  '/configuracoes/whatsapp': typeof AuthedConfiguracoesWhatsappRoute
  '/clientes': typeof AuthedClientesIndexRoute
  '/configuracoes': typeof AuthedConfiguracoesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/bem-vindo': typeof BemVindoRoute
  '/_authed/agenda': typeof AuthedAgendaRoute
  '/_authed/configuracoes': typeof AuthedConfiguracoesRouteWithChildren
  '/_authed/fila': typeof AuthedFilaRoute
  '/_public/cadastro': typeof PublicCadastroRoute
  '/_public/esqueci-senha': typeof PublicEsqueciSenhaRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/redefinir-senha': typeof PublicRedefinirSenhaRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/clientes/$customerId': typeof AuthedClientesCustomerIdRoute
  '/_authed/configuracoes/agendamento': typeof AuthedConfiguracoesAgendamentoRoute
  '/_authed/configuracoes/conta': typeof AuthedConfiguracoesContaRoute
  '/_authed/configuracoes/pagamentos': typeof AuthedConfiguracoesPagamentosRoute
  '/_authed/configuracoes/painel': typeof AuthedConfiguracoesPainelRoute
  '/_authed/configuracoes/profissionais': typeof AuthedConfiguracoesProfissionaisRoute
  '/_authed/configuracoes/salao': typeof AuthedConfiguracoesSalaoRoute
  '/_authed/configuracoes/servicos': typeof AuthedConfiguracoesServicosRoute
  '/_authed/configuracoes/whatsapp': typeof AuthedConfiguracoesWhatsappRoute
  '/_authed/clientes/': typeof AuthedClientesIndexRoute
  '/_authed/configuracoes/': typeof AuthedConfiguracoesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/bem-vindo'
    | '/agenda'
    | '/configuracoes'
    | '/fila'
    | '/cadastro'
    | '/esqueci-senha'
    | '/login'
    | '/redefinir-senha'
    | '/clientes/$customerId'
    | '/configuracoes/agendamento'
    | '/configuracoes/conta'
    | '/configuracoes/pagamentos'
    | '/configuracoes/painel'
    | '/configuracoes/profissionais'
    | '/configuracoes/salao'
    | '/configuracoes/servicos'
    | '/configuracoes/whatsapp'
    | '/clientes/'
    | '/configuracoes/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/bem-vindo'
    | '/agenda'
    | '/fila'
    | '/cadastro'
    | '/esqueci-senha'
    | '/login'
    | '/redefinir-senha'
    | '/clientes/$customerId'
    | '/configuracoes/agendamento'
    | '/configuracoes/conta'
    | '/configuracoes/pagamentos'
    | '/configuracoes/painel'
    | '/configuracoes/profissionais'
    | '/configuracoes/salao'
    | '/configuracoes/servicos'
    | '/configuracoes/whatsapp'
    | '/clientes'
    | '/configuracoes'
  id:
    | '__root__'
    | '/_authed'
    | '/_public'
    | '/bem-vindo'
    | '/_authed/agenda'
    | '/_authed/configuracoes'
    | '/_authed/fila'
    | '/_public/cadastro'
    | '/_public/esqueci-senha'
    | '/_public/login'
    | '/_public/redefinir-senha'
    | '/_authed/'
    | '/_authed/clientes/$customerId'
    | '/_authed/configuracoes/agendamento'
    | '/_authed/configuracoes/conta'
    | '/_authed/configuracoes/pagamentos'
    | '/_authed/configuracoes/painel'
    | '/_authed/configuracoes/profissionais'
    | '/_authed/configuracoes/salao'
    | '/_authed/configuracoes/servicos'
    | '/_authed/configuracoes/whatsapp'
    | '/_authed/clientes/'
    | '/_authed/configuracoes/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  BemVindoRoute: typeof BemVindoRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bem-vindo': {
      id: '/bem-vindo'
      path: '/bem-vindo'
      fullPath: '/bem-vindo'
      preLoaderRoute: typeof BemVindoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agenda': {
      id: '/_authed/agenda'
      path: '/agenda'
      fullPath: '/agenda'
      preLoaderRoute: typeof AuthedAgendaRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/configuracoes': {
      id: '/_authed/configuracoes'
      path: '/configuracoes'
      fullPath: '/configuracoes'
      preLoaderRoute: typeof AuthedConfiguracoesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/fila': {
      id: '/_authed/fila'
      path: '/fila'
      fullPath: '/fila'
      preLoaderRoute: typeof AuthedFilaRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_public/cadastro': {
      id: '/_public/cadastro'
      path: '/cadastro'
      fullPath: '/cadastro'
      preLoaderRoute: typeof PublicCadastroRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/esqueci-senha': {
      id: '/_public/esqueci-senha'
      path: '/esqueci-senha'
      fullPath: '/esqueci-senha'
      preLoaderRoute: typeof PublicEsqueciSenhaRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/redefinir-senha': {
      id: '/_public/redefinir-senha'
      path: '/redefinir-senha'
      fullPath: '/redefinir-senha'
      preLoaderRoute: typeof PublicRedefinirSenhaRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authed/clientes/': {
      id: '/_authed/clientes/'
      path: '/clientes'
      fullPath: '/clientes/'
      preLoaderRoute: typeof AuthedClientesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/clientes/$customerId': {
      id: '/_authed/clientes/$customerId'
      path: '/clientes/$customerId'
      fullPath: '/clientes/$customerId'
      preLoaderRoute: typeof AuthedClientesCustomerIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/configuracoes/': {
      id: '/_authed/configuracoes/'
      path: '/'
      fullPath: '/configuracoes/'
      preLoaderRoute: typeof AuthedConfiguracoesIndexRouteImport
      parentRoute: typeof AuthedConfiguracoesRoute
    }
    '/_authed/configuracoes/agendamento': {
      id: '/_authed/configuracoes/agendamento'
      path: '/agendamento'
      fullPath: '/configuracoes/agendamento'
      preLoaderRoute: typeof AuthedConfiguracoesAgendamentoRouteImport
      parentRoute: typeof AuthedConfiguracoesRoute
    }
    '/_authed/configuracoes/conta': {
      id: '/_authed/configuracoes/conta'
      path: '/conta'
      fullPath: '/configuracoes/conta'
      preLoaderRoute: typeof AuthedConfiguracoesContaRouteImport
      parentRoute: typeof AuthedConfiguracoesRoute
    }
    '/_authed/configuracoes/pagamentos': {
      id: '/_authed/configuracoes/pagamentos'
      path: '/pagamentos'
      fullPath: '/configuracoes/pagamentos'
      preLoaderRoute: typeof AuthedConfiguracoesPagamentosRouteImport
      parentRoute: typeof AuthedConfiguracoesRoute
    }
    '/_authed/configuracoes/painel': {
      id: '/_authed/configuracoes/painel'
      path: '/painel'
      fullPath: '/configuracoes/painel'
      preLoaderRoute: typeof AuthedConfiguracoesPainelRouteImport
      parentRoute: typeof AuthedConfiguracoesRoute
    }
    '/_authed/configuracoes/profissionais': {
      id: '/_authed/configuracoes/profissionais'
      path: '/profissionais'
      fullPath: '/configuracoes/profissionais'
      preLoaderRoute: typeof AuthedConfiguracoesProfissionaisRouteImport
      parentRoute: typeof AuthedConfiguracoesRoute
    }
    '/_authed/configuracoes/salao': {
      id: '/_authed/configuracoes/salao'
      path: '/salao'
      fullPath: '/configuracoes/salao'
      preLoaderRoute: typeof AuthedConfiguracoesSalaoRouteImport
      parentRoute: typeof AuthedConfiguracoesRoute
    }
    '/_authed/configuracoes/servicos': {
      id: '/_authed/configuracoes/servicos'
      path: '/servicos'
      fullPath: '/configuracoes/servicos'
      preLoaderRoute: typeof AuthedConfiguracoesServicosRouteImport
      parentRoute: typeof AuthedConfiguracoesRoute
    }
    '/_authed/configuracoes/whatsapp': {
      id: '/_authed/configuracoes/whatsapp'
      path: '/whatsapp'
      fullPath: '/configuracoes/whatsapp'
      preLoaderRoute: typeof AuthedConfiguracoesWhatsappRouteImport
      parentRoute: typeof AuthedConfiguracoesRoute
    }
  }
}

interface AuthedConfiguracoesRouteChildren {
  AuthedConfiguracoesAgendamentoRoute: typeof AuthedConfiguracoesAgendamentoRoute
  AuthedConfiguracoesContaRoute: typeof AuthedConfiguracoesContaRoute
  AuthedConfiguracoesPagamentosRoute: typeof AuthedConfiguracoesPagamentosRoute
  AuthedConfiguracoesPainelRoute: typeof AuthedConfiguracoesPainelRoute
  AuthedConfiguracoesProfissionaisRoute: typeof AuthedConfiguracoesProfissionaisRoute
  AuthedConfiguracoesSalaoRoute: typeof AuthedConfiguracoesSalaoRoute
  AuthedConfiguracoesServicosRoute: typeof AuthedConfiguracoesServicosRoute
  AuthedConfiguracoesWhatsappRoute: typeof AuthedConfiguracoesWhatsappRoute
  AuthedConfiguracoesIndexRoute: typeof AuthedConfiguracoesIndexRoute
}

const AuthedConfiguracoesRouteChildren: AuthedConfiguracoesRouteChildren = {
  AuthedConfiguracoesAgendamentoRoute: AuthedConfiguracoesAgendamentoRoute,
  AuthedConfiguracoesContaRoute: AuthedConfiguracoesContaRoute,
  AuthedConfiguracoesPagamentosRoute: AuthedConfiguracoesPagamentosRoute,
  AuthedConfiguracoesPainelRoute: AuthedConfiguracoesPainelRoute,
  AuthedConfiguracoesProfissionaisRoute: AuthedConfiguracoesProfissionaisRoute,
  AuthedConfiguracoesSalaoRoute: AuthedConfiguracoesSalaoRoute,
  AuthedConfiguracoesServicosRoute: AuthedConfiguracoesServicosRoute,
  AuthedConfiguracoesWhatsappRoute: AuthedConfiguracoesWhatsappRoute,
  AuthedConfiguracoesIndexRoute: AuthedConfiguracoesIndexRoute,
}

const AuthedConfiguracoesRouteWithChildren =
  AuthedConfiguracoesRoute._addFileChildren(AuthedConfiguracoesRouteChildren)

interface AuthedRouteChildren {
  AuthedAgendaRoute: typeof AuthedAgendaRoute
  AuthedConfiguracoesRoute: typeof AuthedConfiguracoesRouteWithChildren
  AuthedFilaRoute: typeof AuthedFilaRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedClientesCustomerIdRoute: typeof AuthedClientesCustomerIdRoute
  AuthedClientesIndexRoute: typeof AuthedClientesIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAgendaRoute: AuthedAgendaRoute,
  AuthedConfiguracoesRoute: AuthedConfiguracoesRouteWithChildren,
  AuthedFilaRoute: AuthedFilaRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedClientesCustomerIdRoute: AuthedClientesCustomerIdRoute,
  AuthedClientesIndexRoute: AuthedClientesIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

interface PublicRouteChildren {
  PublicCadastroRoute: typeof PublicCadastroRoute
  PublicEsqueciSenhaRoute: typeof PublicEsqueciSenhaRoute
  PublicLoginRoute: typeof PublicLoginRoute
  PublicRedefinirSenhaRoute: typeof PublicRedefinirSenhaRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicCadastroRoute: PublicCadastroRoute,
  PublicEsqueciSenhaRoute: PublicEsqueciSenhaRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicRedefinirSenhaRoute: PublicRedefinirSenhaRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  BemVindoRoute: BemVindoRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
